import styled, { css } from "styled-components";

export const TabsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  background-color: white;
  overflow: overlay !important;


  scrollbar-width: none;
  ::-webkit-scrollbar {
    width: 0px;
    height: 0px;
  }

  @media only screen and (min-width: 768px) {
    scrollbar-width: thin;
    scrollbar-color: #E3E3E3 transparent;

    ::-webkit-scrollbar {
      width: 16px;
      height: 16px;
      background: transparent;
    }

    ::-webkit-scrollbar-track-piece  {
      background: transparent;
    }

    ::-webkit-scrollbar-thumb:vertical {
      background: linear-gradient(to left, #E3E3E3 4px, transparent 0%);
      border-radius: 10px;
    }

    ::-webkit-scrollbar-thumb:horizontal {
      background: linear-gradient(to top, #E3E3E3 4px, transparent 0%);
      border-radius: 10px;
    }

    ::-webkit-scrollbar-thumb:hover {
      background: #E3E3E3;
    }
  }
`;